import { ChangeDetectorRef, Component, inject, Injector, input } from '@angular/core';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { ListService } from '@shared/modules/list/services/list.service';
import { WindowHelper } from '@shared/helpers/window.helper';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'list-filters-btn-v2',
  templateUrl: './list-filters-btn-v2.component.html',
  styleUrls: ['./list-filters-btn-v2.component.scss']
})
export class ListFiltersButtonV2Component {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTypes = ButtonTypes;
  readonly WindowHelper = WindowHelper;

  protected filters = input(undefined);
  protected readonly hasActiveFilters = input(false);

  protected readonly dialogRef = inject(MatDialog);
  private readonly changes = inject(ChangeDetectorRef);
  private readonly service = inject(ListService);
  private readonly injector = inject(Injector);

  protected shouldShowActiveDot(): boolean {
    if (this.hasActiveFilters()) return true;

    const hasActiveQueryFilters = Object.entries(this.service.getParams()).some(([key, value]) => {
      if (!key.startsWith('filters[')) return false;
      return (
        value !== null && value !== undefined && value !== '' &&
        value !== 0 && value !== false && value !== '0' && value !== 'false'
      );
    });
    if (hasActiveQueryFilters) return true;

    return Object.values(this.service.chips || {}).some((value) => Array.isArray(value) && value.length > 0);
  }

  openFilters() {
    if (!this.filters()) return;
    this.service.isFiltersOpened = true;
    const dialogInjector = Injector.create({
      providers: [{ provide: ListService, useValue: this.service }],
      parent: this.injector
    });
    const dialog = this.dialogRef.open(this.filters(), {
      disableClose: true,
      injector: dialogInjector
    });

    dialog.afterClosed().subscribe(() => {
      this.service.isFiltersOpened = false;
      this.changes.markForCheck();
    });
  }
}
